import { BYO_LIVE_SCORE_START_UPDATES, BYO_LIVE_SCORE_STOP_UPDATES, BYO_LIVE_SCORE_UPDATE } from '../constants';
export const startLiveScoreUpdates = () => ({
    type: BYO_LIVE_SCORE_START_UPDATES,
});
export const stopLiveScoreUpdates = () => ({
    type: BYO_LIVE_SCORE_STOP_UPDATES,
});
export const updateLiveScore = (payload) => ({
    type: BYO_LIVE_SCORE_UPDATE,
    payload,
});
